<template>
  <div
    class="harikadi-page"
    :style="harikadiPageStyle">
    <v-layout wrap>
      <v-flex>
        <section class="harikadi-section">
          <div>
            <!-- <v-card
              v-if="process.load"
              flat
              height="250"
              width="100vw"
              color="#00000040">
              <v-skeleton-loader
                :loading="process.load"
                transition="scale-transition"
                :tile="false"
                class="ma-auto load_card_x_large"
                type="image"
                style="width: 100% !important; height: 100% !important; min-height: 100% !important;">
              </v-skeleton-loader>
            </v-card> -->
            <div v-if="!process.list">
                <!-- <v-card
                  flat
                  cover
                  v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' "
                  class="background-default">
                  <v-img :src="require('@/assets/image/Candi-Prambanan.jpg')" width="100%" height="250" style="opacity: 0.75;" :gradient="`to right, ${set_color_rgb_up}, #000000a6`" class="img_center align-center">

                    <div class="d-flex align-center justify-center font-weight-black">
                      <div class="text-center">
                        <div
                          class="text-h4 white--text justify-center mb-2 pt-6"
                          style="font-weight: 500;">
                          {{ category[selected.category].category_title }} <span v-if="selected.category === 0">Berita</span>
                        </div>

                        <div
                          class="body-1 white--text text-center mb-4"
                          style="opacity: 50%; font-weight: 500;">
                          Mengenal {{ category[selected.category].category_title }} <span v-if="selected.category === 0">Berita</span> di kabupaten Klaten.
                        </div>
                      </div>
                    </div>

                  </v-img>
                </v-card> -->
            </div>
          </div>
          <v-container :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'px-0' : ''">
            <v-row v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'" class="harikadi-hero-row">
              <v-col cols="12" class="harikadi-hero-col">
                <div class="harikadi-hero" :style="{ '--harikadi-hero-bg': set_color, '--harikadi-hero-dark': set_color_dark }">
                  <div class="harikadi-hero-inner">
                    <div class="harikadi-hero-text">
                      <h1 class="harikadi-hero-title">Hari Jadi Kabupaten Klaten</h1>
                      <p class="harikadi-hero-subtitle">Informasi Hari Jadi Kabupaten Klaten</p>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>

            <div>
              <v-row>
                <v-col cols="12" md="9" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pt-0' : ''">
                  <div v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'" class="harikadi-mobile-header mb-4">
                    <h1 class="harikadi-mobile-title">Hari Jadi Kabupaten Klaten</h1>
                  </div>
                <!-- <v-col cols="12" md="3">
                  <v-skeleton-loader
                    :loading="process.load"
                    v-if="process.load"
                    transition="scale-transition"
                    :tile="false"
                    class="ma-auto load_card_x_large"
                    type="image"
                    style="width: 100% !important; height: 800px !important; min-height: 800px !important;">
                  </v-skeleton-loader>
                  <v-card
                    class="mx-auto"
                    v-if="!process.load"
                    style="border-radius: 15px;"
                    min-height="100%"
                    :class="'elevation-0'"
                    >
                    <v-card-title>
                      <div class="font-weight-medium" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'  ? 'text-h6' : 'body-1 text-center w-100'">
                        <span>Kategori</span> Berita
                      </div>
                    </v-card-title>
                    <v-list flat v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
                      <v-list-item-group
                        v-model="selected.category"
                        mandatory
                        :color="set_color"
                      >
                        <v-list-item
                          v-for="(item, i) in category"
                          :key="i"
                          @click="selected.category = i; changeQuery(item.category_name); fetch(item.id)"
                        >
                          <v-list-item-icon class="mr-2">
                            <v-img
                              width="40px"
                              alt="Kabupaten Klaten"
                              :src="item.category_icon_url === '' ? require('@/assets/image/no-photo.png') : item.category_icon_url">
                            </v-img>
                          </v-list-item-icon>

                          <v-list-item-content>
                            <v-list-item-title>{{ item.category_title }}</v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action class="ml-0 my-0">
                            <v-chip
                              class="ma-2"
                              small
                              style="min-width: 40px; text-align: center; justify-content: center;"
                              text-color="white"
                              :color="`${set_color}`"
                            >
                              {{ item.count }}
                            </v-chip>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                    <v-slide-group
                      v-model="selected.category"
                      class="px-0 pb-5"
                      mandatory
                      show-arrows
                      v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'"
                    >
                      <v-slide-item
                        v-for="n in category"
                        :key="n"
                        v-slot="{ active }"
                      >
                      <v-btn
                          class="mx-2 text-capitalize"
                          :input-value="active"
                          :color="active ? `${set_color}` : ``"
                          :active-class="`white--text`"
                          depressed
                          rounded
                          @click="selected.category = i; changeQuery(n.category_name); fetch(n.id)"
                        >
                          {{ n.category_title }}
                        </v-btn>
                      </v-slide-item>
                    </v-slide-group>
                  </v-card>
                </v-col> -->
                  <v-card flat
                    v-for="(item, index) in process.list ? 8 : list"
                    :key="index"
                    style="border-radius: 6px;"
                    class="mb-5">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.list"
                      type="list-item-avatar-three-line">
                      <div>
                        <div v-if="!process.list && list.length > 0">
                          <v-list three-line>
                            <template>
                              <v-list-item>
                                <v-list-item-avatar tile :size="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 80 : 60">
                                  <v-img :src="require('@/assets/icon/loudspeaker.png')"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content :to="`/hari-jadi-klaten/${item.slug}?q=${item.id}`">
                                  <div @mouseover="voiceHover(item.title)" style="cursor: pointer">{{ item.title }}</div>
                                  <v-list-item-subtitle>
                                    <div>
                                      <v-icon
                                        size="12">
                                        mdi-account-circle-outline
                                      </v-icon>
                                      <span class="me-1 font-small">Admin</span>
                                      <span class="ml-2">
                                        <v-icon
                                          size="12">
                                          mdi-calendar-range
                                        </v-icon>
                                        <span class="me-1 font-small"> {{ item.publish_datetime | date }} </span>
                                      </span>
                                      <span class="ml-2">
                                        <v-icon
                                          size="12">
                                          mdi-eye
                                        </v-icon>
                                        <span class="me-1 font-small">Dilihat {{ item.view_count }} Kali </span>
                                      </span>
                                    </div>
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle>
                                    <div class="caption font-weight-light three-line my-2" style="opacity: 60%;">
                                      <span v-html="item.content.replace(/(<([^>]+)>)/ig, '')"></span>
                                    </div>
                                  </v-list-item-subtitle>
                                  <!-- <div class="text-right mt-5">
                                    <v-btn
                                      style="border-radius: 6px;"
                                      height="40"
                                      elevation="0"
                                      :small="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? true : true"
                                      color="blue"
                                      class="body-2 text-capitalize font-weight-bold white--text">

                                      <v-icon size="20" class="mr-2">mdi-text-box-search-outline</v-icon>
                                      Lihat Detail
                                    </v-btn>
                                  </div> -->
                                </v-list-item-content>
                                <!-- <v-list-item-action>
                                  <v-chip
                                    class="pa-2"
                                    text-color="white"
                                    x-small
                                    color="green"
                                    label
                                  >
                                    Berlaku
                                  </v-chip>
                                </v-list-item-action> -->
                              </v-list-item>
                              <v-divider></v-divider>
                            <div class="text-right pa-5">
                              <!-- <v-btn
                                style="border-radius: 6px;"
                                elevation="0"
                                :small="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? false : true"
                                color="red"
                                class="text-subtitle-2 text-capitalize font-weight-bold white--text">

                                <v-icon size="20" class="mr-2">mdi-file-document-outline</v-icon>
                                Abstrak
                              </v-btn>
                              <v-btn
                                style="border-radius: 6px;"
                                elevation="0"
                                :small="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? false : true"
                                color="green"
                                class="text-subtitle-2 text-capitalize font-weight-bold white--text">

                                <v-icon size="20" class="mr-2">mdi-download</v-icon>
                                Download
                              </v-btn> -->
                              <v-btn
                                style="border-radius: 6px;"
                                elevation="0"
                                @mouseover="voiceHover('Lihat Detail')"
                                :to="`/hari-jadi-klaten/${item.slug}?q=${item.id}`"
                                :small="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? false : true"
                                color="blue"
                                class="text-subtitle-2 text-capitalize font-weight-bold white--text">

                                <v-icon size="20" class="mr-2">mdi-text-box-search-outline</v-icon>
                                Lihat Detail
                              </v-btn>
                            </div>
                            </template>
                          </v-list>
                        </div>

                      </div>
                    </v-skeleton-loader>
                  </v-card>

                  <div v-if="!process.list && pagination.total_data > pageSize"
                    class="harikadi-pagination mt-4 mb-2">
                    <div class="harikadi-pagination-inner">
                      <div class="body-2 harikadi-pagination-info">
                        Total seluruh data: {{ (pagination.total_data || 0).toLocaleString('id-ID') }}
                      </div>
                      <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        :total-visible="$vuetify.breakpoint.smAndDown ? 5 : 7"
                        :color="set_color"
                        circle
                        prev-icon="mdi-chevron-left"
                        next-icon="mdi-chevron-right"
                        class="harikadi-pagination-control"
                        @input="onPageChange"
                      />
                    </div>
                  </div>

                  <Empty v-if="!process.list && pagination.total_page < 1"
                    class="py-12"
                    margin="my-16"
                    size="125"
                    message="Hari Jadi Klaten" />

                </v-col>
                <v-col cols="12" md="3">

                  <Sidebar />
                </v-col>
              </v-row>
            </div>


          </v-container>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { createSEOMeta } from '@/utils/seo'
  export default {
    middleware: false,
    data () {
      return {
        search: '',
        category: [
          {
            icon: 'mdi-newspaper',
            text: 'Berita',
            link: '/berita?category=utama'
          },
          {
            icon: 'mdi-newspaper-variant',
            text: 'Berita OPD',
            link: '/berita?category=opd'
          },
          {
            icon: 'mdi-newspaper-variant-outline',
            text: 'Berita Wilayah',
            link: '/berita?category=wilayah'
          },
        ],
        selected: {
          category: 0
        },
        filter: {
          category: ''
        },
        total_category: 0,
        list: [],
        pagination: {},
        currentPage: 1,
        pageSize: 12,
        process: {
          load: false,
          list: false
        },
        message: {
          success: '',
          error: ''
        },
        // SEO
        content: {
          url: '/hari-jadi-klaten',
          title: 'Hari Jadi Klaten',
          description: 'Hari Jadi Kabupaten Klaten',
          image: require('@/assets/logo/favicon.png')
        }
      }
    },
    head () {
      return {
        title: this.content.title,
        meta: createSEOMeta(this.content)
      }
    },
    // components: {
    //   Utama: () => import(/* webpackPrefetch: true */ '@/components/berita/utama.vue'),
    //   OPD: () => import(/* webpackPrefetch: true */ '@/components/berita/opd.vue'),
    //   Wilayah: () => import(/* webpackPrefetch: true */ '@/components/berita/wilayah.vue'),
    // },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/Empty'),
      Sidebar: () => import(/* webpackPrefetch: true */ '@/components/sidebar/index')
    },
    watch: {},
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.member.auth.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      set_color_dark () {
        const hex = (this.$store.state.header.config.color || '#B71C1C').replace(/^#/, '')
        const r = Math.max(0, parseInt(hex.slice(0, 2), 16) * 0.65)
        const g = Math.max(0, parseInt(hex.slice(2, 4), 16) * 0.65)
        const b = Math.max(0, parseInt(hex.slice(4, 6), 16) * 0.65)
        return '#' + [r, g, b].map(x => Math.round(x).toString(16).padStart(2, '0')).join('')
      },
      harikadiPalette () {
        const primary = this.set_color || '#B71C1C'
        return {
          '--harikadi-bg': '#FAF7F5',
          '--harikadi-surface': '#FFFFFF',
          '--harikadi-text': '#2D2D2D',
          '--harikadi-text-muted': '#6B6B6B',
          '--harikadi-border': '#E8E4E0',
          '--harikadi-primary': primary,
          '--harikadi-shadow': '0 2px 12px rgba(45, 45, 45, 0.06)'
        }
      },
      harikadiPageStyle () {
        const isDesktop = this.$vuetify.breakpoint.name !== 'xs' && this.$vuetify.breakpoint.name !== 'sm'
        const padding = isDesktop
          ? { paddingTop: '128px', paddingBottom: '280px' }
          : { paddingTop: '64px', paddingBottom: '650px' }
        return Object.assign({}, this.harikadiPalette, padding)
      },
      totalPages () {
        const total = this.pagination.total_page ?? Math.ceil((this.pagination.total_data || 0) / this.pageSize)
        return Math.max(1, total)
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchCategory()
      this.fetch()
    },
    methods: {
      voiceHover (item) {
        responsiveVoice.cancel(); // Cancel anything else that may currently be speaking
        responsiveVoice.speak(item, 'Indonesian Female');
      },
      async fetchCategory (id, type) {
        this.process.load = type === undefined ? true : false
        this.process.list = true

        let params = {
          limit: 1000000,
          par_id: '1'
        }

        await this.$axios.$get(`${process.env.API}sites/article/category`, { params })
        .then(response => {
          let res = response

          if (res.status === 200) {
            this.category = [
              {
                category_title: "Semua Kategori",
                category_icon_url: require('@/assets/icon/app.png'),
                id: '',
                category_name: "semua-kategori",
                count: 0
              }
            ]
            let category = []
            category = res.results.data.map(item => {
                const container = {};

                container.category_title = item.title;
                container.category_icon_url = item.icon_url;
                container.id = item.id;
                container.category_name = item.slug;
                container.count = item.count

                // this.category = container;
                return container
              })


            for (let i in category) {
              this.category.push(
                {
                  category_title: category[i].category_title,
                  category_icon_url: category[i].category_icon_url,
                  id: category[i].id,
                  category_name: category[i].category_name,
                  count: category[i].count
                }
              )

            }

            for (let i in this.category) {
              this.total_category += parseInt(this.category[i].count)

            }

            this.process.load = false
            this.category[0].count = this.total_category
            // this.changeLink()
          }
        })
      },
      onPageChange () {
        this.fetch()
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      async fetch () {
        this.process.list = true

        let params = {
          limit: this.pageSize,
          page: this.currentPage,
          'category_id': '15',
          sort: '-publish_datetime'
        }

        await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
        .then(response => {
          let res = response

          if (res.status === 200) {
            this.list = res.results.data
            this.pagination = res.results.pagination
          }
          this.process.list = false
          this.process.load = false
        })
      },
      // changeLink() {
      //   window.scrollTo({
      //     top: 0,
      //     behavior: 'smooth'
      //   })
      //   let status = false
      //   let id = 0
      //   this.selected.category = 0
      //   this.filter.category = ''


      //   if (this.$route.query.category !== undefined) {
      //     for(let i = 0; i < this.category.length; i++){
      //       if (this.category[i].category_name === this.$route.query.category) {
      //         this.filter.category = this.category[i].id
      //         this.selected.category = i
      //         status = true
      //       } else {
      //         // status = false
      //       }
      //     }
      //     // if (query === 'wisata') {
      //     //     this.selected = {
      //     //       category: 0,
      //     //     }
      //     // } else if (query === 'kuliner') {
      //     //   this.selected = {
      //     //     category: 1
      //     //   }
      //     // }
      //     // this.fetch(id)
      //   }
      //   // console.log(status)
      //   if (status === false) {
      //     this.$router.push(`/pengumuman`)
      //   }

      //   console.log(id)

      //   this.fetch()
      // },
      // changeQuery(name) {
      //   if(name === '') {
      //     if (this.$route.query.search !== undefined) {
      //       this.$router.replace({'path': `/berita`, 'query': {'search': this.$route.query.search}})
      //     } else {
      //       this.$router.replace({'path': `/berita`})
      //     }
      //   } else {
      //     if (this.$route.query.search === undefined) {
      //       this.$router.replace({'path': `/berita`, 'query': {'category': name}})
      //     } else {
      //       this.$router.replace({'path': `/berita`, 'query': {'category': name, 'search': this.$route.query.search}})
      //     }
      //   }
      // },
      // toDetail(item) {
      //   this.$router.push(`/pengumuman/${(item.title.split('-').join('=').split(' ').join('-').split('/').join('>'))}?q=${item.id}`)
      // },
    }
  }
</script>

<style scoped>
.harikadi-page { background-color: var(--harikadi-bg); min-height: 100vh; box-sizing: border-box; }
.harikadi-section { min-height: 0; }
.harikadi-hero-row { margin-bottom: 2rem; }
.harikadi-hero-col { padding-top: 0; padding-bottom: 0; }
.harikadi-hero {
  background: linear-gradient(135deg, var(--harikadi-hero-bg) 0%, var(--harikadi-hero-dark) 100%);
  border-radius: 16px; padding: 1.75rem 2rem; box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
}
.harikadi-hero-inner { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 1.5rem; }
.harikadi-hero-text { flex: 0 0 auto; }
.harikadi-hero-title { font-size: 1.35rem; font-weight: 700; color: #fff; margin: 0 0 0.25rem 0; letter-spacing: -0.02em; }
.harikadi-hero-subtitle { font-size: 0.9375rem; color: rgba(255, 255, 255, 0.88); margin: 0; }
.harikadi-mobile-header {
  background: var(--harikadi-surface); border-radius: 12px; padding: 1rem;
  box-shadow: var(--harikadi-shadow); border: 1px solid var(--harikadi-border);
}
.harikadi-mobile-title { font-size: 1.375rem; font-weight: 700; color: var(--harikadi-text); margin: 0; }
.harikadi-pagination { width: 100%; }
.harikadi-pagination-inner {
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 1rem;
  padding: 1rem 1.25rem; background: var(--harikadi-surface); border: 1px solid var(--harikadi-border);
  border-radius: 12px; box-shadow: var(--harikadi-shadow);
}
.harikadi-pagination-info { color: var(--harikadi-text-muted); font-size: 0.875rem; }
.harikadi-pagination-control.v-pagination { flex-wrap: wrap; justify-content: center; }
.harikadi-pagination-control.v-pagination .v-pagination__item,
.harikadi-pagination-control.v-pagination .v-pagination__navigation {
  min-width: 36px !important; width: 36px !important; height: 36px !important; margin: 0 3px !important;
  font-weight: 600; font-size: 0.875rem; box-shadow: none; border: 1px solid var(--harikadi-border);
}
.harikadi-pagination-control.v-pagination .v-pagination__item--is-active { box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12); }
.harikadi-pagination-control.v-pagination .v-pagination__more { margin: 0 2px; min-width: 28px; }
@media (max-width: 600px) {
  .harikadi-pagination-inner { flex-direction: column; align-items: stretch; text-align: center; }
  .harikadi-pagination-control.v-pagination .v-pagination__item,
  .harikadi-pagination-control.v-pagination .v-pagination__navigation {
    min-width: 32px !important; width: 32px !important; height: 32px !important;
  }
}
</style>
